import { HDMPriceDisplay } from '@/components/blocks/HDMPriceDisplay';
import { Linkable } from '@/components/blocks/Linkable';
import { RatingCard } from '@/components/blocks/RatingCard';
import { Column } from '@/components/content/HdmSkucomparer/parts/Column';
import { ProductImage } from '@/components/content/HdmSkucomparer/parts/ProductImage';
import { columnProductStyles } from '@/components/content/HdmSkucomparer/styles';
import { useProductCard } from '@/data/Content/_ProductCard';
import { useLocalization } from '@/data/Localization';
import { ProductType } from '@/data/types/Product';
import { useUser } from '@/data/User';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import { Box, Button, CircularProgress, Typography } from '@mui/material';

export const ColumnProduct = ({
	product,
	...props
}: {
	product: ProductType;
	isVisible?: boolean;
	isMainProduct?: boolean;
}) => {
	const localization = useLocalization('HDMSkucomparer');
	const { loading } = useUser();

	const { onAddToCart, addToDefaultWishlist, isAddingToCart, isAddingToWishlist, loginStatus } =
		useProductCard(product);

	const onClickAddToCart = (e: React.MouseEvent<HTMLElement>) => {
		onAddToCart(product)(e);
	};

	const onClickAddToWishlist = () => {
		addToDefaultWishlist({ partNumber: product.partNumber });
	};

	return (
		<Column {...props}>
			<Box display="flex" flexDirection="column" gap={2}>
				<ProductImage product={product} />

				<Typography variant="headingTitle" component="h4" sx={columnProductStyles.productName}>
					{product.name.toLowerCase()}
				</Typography>
			</Box>

			<Box display="flex" flexDirection="column" gap={2}>
				<HDMPriceDisplay price={product.productPrice} />

				<RatingCard ratings={product.ratings} />

				<Typography>
					{props.isMainProduct ? (
						localization.ThisProduct.t()
					) : (
						<Linkable sx={columnProductStyles.productLink} href={product.seo.href}>
							{localization.ViewDetails.t()}
						</Linkable>
					)}
				</Typography>

				<Box sx={columnProductStyles.buttonsContainer}>
					<Button
						fullWidth
						sx={columnProductStyles.addToCartButton}
						disabled={loading || isAddingToCart}
						variant={props.isMainProduct ? 'contained' : 'outlined'}
						onClick={onClickAddToCart}
					>
						{isAddingToCart ? (
							<CircularProgress color={props.isMainProduct ? 'inherit' : 'primary'} size={24} />
						) : (
							<AddShoppingCartIcon />
						)}
					</Button>

					{loginStatus ? (
						<Button
							sx={columnProductStyles.addToWishlistButton}
							variant="text"
							onClick={onClickAddToWishlist}
						>
							{isAddingToWishlist ? (
								<CircularProgress color="inherit" size={24} />
							) : (
								<FavoriteBorderOutlinedIcon />
							)}

							<Typography variant="bodySubText">{localization.Save.t()}</Typography>
						</Button>
					) : null}
				</Box>
			</Box>
		</Column>
	);
};
